import { meta } from './meta';
import { ui } from './ui';
import { values } from './values';
import * as Redux from 'redux';
import { IState } from '../interfaces/state';

export const Main: Redux.Reducer<IState> = Redux.combineReducers({
    meta,
    ui,
    values
});
